import accountAuthorizationMutations from "./mutations";
import accountAuthorizationActions from "./actions";
import accountAuthorizationGetters from "./getters";
import initialState from "./model";

export default {
  namespaced: true,
  state() {
    return initialState();
  },
  mutations: accountAuthorizationMutations,
  actions: accountAuthorizationActions,
  getters: accountAuthorizationGetters,
};
